import { APP_BACKGROUND_COLOR, APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const styles = {
  genreSelectField: {
    width: "92%",
    color: "white",
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
  genreLiTag: {
    margin: "0",
    padding: "0",
    fontFamily: FONT_FAMILY,
    color: "white",
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
  genreCheckBox: {
    marginRight: 8,
    color: "white",
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
  privacyPolicyContainer: {
    display: "inline-block",
    verticalAlign: "top",
    marginBottom: 40,
    padding: 5,
  } as const,
  walletContainer: {
    width: "390px",
    display: "flex",
    justifyContent: "space-around",
    marginTop: "15px",
  } as const,
  textArea: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: APP_COLOR,
    },
  } as const,
  goToBillingPortalButton: {
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    padding: 1,
    fontSize: 15,
    ":hover": { backgroundColor: APP_HOVER_COLOR, color: "black" },
    textTransform: "none",
    color: "black",
    marginTop: "80px",
  } as const,
};
